export default function getAppName(tenant, classroom = null) {
    if (classroom && classroom.productName) {
        return classroom.productName;
    }
    if (tenant && tenant.name) {
        return tenant.name;
    }
    return "";
}